import { ArrowRight } from "lucide-react";

const services = [
  {
    title: "Finestre",
    description: "Finestre in PVC, alluminio e legno con vetri ad alta efficienza energetica. Design moderno e isolamento termico superiore.",
    image: "https://images.pexels.com/photos/11408618/pexels-photo-11408618.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Isolamento Termico", "Antieffrazione", "Risparmio Energetico"]
  },
  {
    title: "Porte Finestre",
    description: "Porte finestre scorrevoli e a battente che collegano gli spazi interni con l'esterno in modo elegante e funzionale.",
    image: "https://images.pexels.com/photos/19184551/pexels-photo-19184551.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Scorrevoli", "A Battente", "Design Elegante"]
  },
  {
    title: "Infissi",
    description: "Infissi su misura realizzati con materiali di prima qualità. Soluzioni personalizzate per ogni esigenza architettonica.",
    image: "https://images.pexels.com/photos/15743361/pexels-photo-15743361.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Su Misura", "Alta Qualità", "Personalizzabili"]
  },
  {
    title: "Persiane",
    description: "Persiane in legno e alluminio che uniscono protezione, privacy e stile. Disponibili in tutti i colori.",
    image: "https://images.pexels.com/photos/6396048/pexels-photo-6396048.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Legno e Alluminio", "Tutti i Colori", "Protezione UV"]
  }
];

export default function ServicesSection() {
  const scrollToQuote = (e) => {
    e.preventDefault();
    const element = document.querySelector("#preventivo");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="servizi" className="py-24 md:py-32 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <p className="text-sm font-bold uppercase tracking-[0.2em] bg-clip-text text-transparent bg-gradient-to-r from-orange-500 via-blue-500 to-purple-500 mb-4">
            I Nostri Servizi
          </p>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[#0B1E36] mb-6">
            Soluzioni Complete per i Tuoi Serramenti
          </h2>
          <p className="text-base md:text-lg text-[#64748B] leading-relaxed">
            Offriamo una gamma completa di serramenti per ogni esigenza. 
            Dalla consulenza iniziale all'installazione finale, ti accompagniamo in ogni fase.
          </p>
        </div>

        {/* Services Grid - Bento Style */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div 
              key={service.title}
              className="service-card bg-white rounded-3xl overflow-hidden border border-[#E2E8F0]/50 group"
              data-testid={`service-card-${service.title.toLowerCase().replace(' ', '-')}`}
            >
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <h3 className="absolute bottom-6 left-6 text-2xl md:text-3xl font-bold text-white">
                  {service.title}
                </h3>
              </div>
              
              <div className="p-6 md:p-8">
                <p className="text-[#64748B] leading-relaxed mb-6">
                  {service.description}
                </p>
                
                <div className="flex flex-wrap gap-2 mb-6">
                  {service.features.map((feature) => (
                    <span 
                      key={feature}
                      className="px-3 py-1.5 bg-[#F1F5F9] text-[#0B1E36] text-sm font-medium rounded-full"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                <button 
                  onClick={scrollToQuote}
                  className="inline-flex items-center gap-2 text-[#007AFF] font-semibold hover:gap-4 transition-all duration-300"
                  data-testid={`service-cta-${service.title.toLowerCase().replace(' ', '-')}`}
                >
                  Richiedi Info
                  <ArrowRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
